<div class="request-word-wrapper">
    <!-- Sitemap Content Section -->
    <div *ngIf="scan.content" class="mb-4">
        <pre>{{ scan.content }}</pre>
    </div>

    <!-- Regular HTML Content Section -->
    <div *ngIf="scan.contents?.original">
        <pre>{{ scan.contents.original }}</pre>
    </div>
</div>
